<template>
  <div class="wrapper">
    <van-nav-bar left-text="我的券" left-arrow fixed @click-left="onClickLeft">
    </van-nav-bar>
    <div class="fixedmune">
      <van-dropdown-menu active-color="#ee0a24">
        <van-dropdown-item
          v-model="value1"
          @change="onClickCardMune"
          :options="option1"
        >
        </van-dropdown-item>
        <van-dropdown-item
          v-model="value2"
          @change="onClickMuneItem"
          :title="munetitle"
          :options="option2"
        ></van-dropdown-item>
      </van-dropdown-menu>
    </div>
    <div v-if="activeShow" class="main-tab">
      <van-tabs :ellipsis="false" v-model="active">
        <van-tab title="店铺券"></van-tab>
        <van-tab title="商品券"></van-tab>
        <van-tab title="工会专属"></van-tab>
        <van-tab title="免费拿(满折/满减)"></van-tab>
      </van-tabs>
    </div>
    <div class="mylist" :class="{'list-active':!activeShow}">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-if="Object.keys(cardsList).length > 0" class="listcell">
          <coupon-cards :cardsList="cardsList"></coupon-cards>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import couponCards from '@/components/content/couponCards'
import { pageProductCards } from '@/api/productCards'
export default {
  name: 'mymoney',
  components: {
    couponCards,
  },
  data() {
    return {
      active: 0,
      activeShow: false,
      cardsList: [],
      list: [],
      query: {
        current: 1,
        size: 10,
        couponUseStatus: 0,
      },
      loading: false,
      finished: false,
      value1: 0,
      value2: 0,
      munetitle: '券类型',
      option1: [
        {
          text: '可使用的券',
          value: 0,
        },
        {
          text: '已使用的券',
          value: 1,
        },
        {
          text: '已过期的券',
          value: 2,
        },
      ],
      option2: [
        {
          text: '全部类型',
          value: '',
        },
        {
          text: '官方福利券',
          value: 6,
        },
        {
          text: '单位福利券',
          value: 'danwei',
        },
        {
          text: '商家优惠券',
          value: 'shangjia',
        },
      ],
    }
  },
  watch: {
    active(val, oldVal) {
      // console.log(val, oldVal)
      switch (val) {
        case 0:
          this.query.current = 1
          this.query.size = 10
          this.query.couponType = [0]
          this.cardsList = []
          this.onLoad()
          break
        case 1:
          this.query.current = 1
          this.query.size = 10
          this.query.couponType = [1]
          this.cardsList = []
          this.onLoad()
          break
        case 2:
          this.query.current = 1
          this.query.size = 10
          this.query.couponType = [3]
          this.cardsList = []
          this.onLoad()
          break
        case 3:
          this.query.current = 1
          this.query.size = 10
          this.query.couponType = [7, 8]
          this.cardsList = []
          this.onLoad()
          break
      }
    },
  },
  methods: {
    onClickLeft() {
      this.$callApp('Android', 'GoBackAppMethod', '')
      this.$callApp('iOS', 'GoBackAppMethod', '')
    },
    // 是否使用劵菜单
    onClickCardMune(item) {
      console.log(item)
      this.query.current = 1
      this.query.size = 10
      this.query.couponUseStatus = item
      this.cardsList = []
      this.onLoad()
    },
    onClickMuneItem(value) {
      console.log('valvalbaaaaaaaaaaaa', value)
      if (value == 'danwei') {
        this.query.current = 1
        this.query.size = 10
        this.query.couponType = [4, 5]
        this.cardsList = []
        this.onLoad()
      }
      if (value == 'shangjia') {
        this.activeShow = true
        this.active = 0
        this.query.current = 1
        this.query.size = 10
        this.query.couponType = [0]
        this.cardsList = []
        this.onLoad()
      } else {
        this.activeShow = false
      }
      if (value == 6) {
        this.query.current = 1
        this.query.size = 10
        this.query.couponType = [6]
        this.cardsList = []
        this.onLoad()
      }
      if (value == '') {
        this.query.current = 1
        this.query.size = 10
        delete this.query.couponType
        this.cardsList = []
        this.onLoad()
      }
      this.option2.forEach((el) => {
        if (value === '') {
          this.munetitle = '券类型'
          return
        } else {
          if (el.value === value) {
            this.munetitle = el.text.substr(0, 5)
            return
          }
        }
      })
    },
    // 分页查询优惠券
    onLoad() {
      pageProductCards(this.query).then((res) => {
        if (res.data.code === 200) {
          this.cardsList = this.cardsList.concat(res.data.data.records)
          this.totalCount = res.data.data.total
          this.query.current++
          // 加载状态结束
          this.loading = false
          // 数据全部加载完成
          if (this.cardsList.length >= this.totalCount) {
            this.finished = true
            console.log('falfalflalflafllaflalflaflalflafllfa')
          }
          this.cardsList.name = 'myCart'
          console.log('this.cardsList', this.cardsList, this.loading)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
* {
  font-size: 16px;
}

.wrapper {
  min-height: 100vh;
  padding-top: 75px;
  background-color: #eee;
}

/deep/.van-nav-bar__text {
  color: black;
  font-size: 16px;
}

/deep/.van-nav-bar .van-icon {
  color: black;
  font-size: 16px;
}

.van-nav-bar {
  line-height: 50px;
  height: 50px;
  background-color: white;
}

.fixedmune {
  position: fixed;
  width: 100%;
  top: 50px;
  z-index: 100;
}

/deep/.van-loading__text {
  font-size: 16px;
}

/deep/.van-dropdown-menu {
  font-size: 16px;
  height: 30px;
  position: static;
  border-bottom: 1px solid #eee;
}

/deep/.van-cell__title {
  font-size: 15px;
  padding: 15px 0px;
}

/deep/.van-dropdown-menu__title::after {
  top: 35%;
  right: -10px;
  width: 4px;
  height: 4px;
}

/deep/.van-ellipsis {
  line-height: 20px;
  font-size: 15px;
}
.optiondiv {
  padding: 5px 1px;
}

.mylist {
  padding: 0px;
}
.list-active{
  margin-top: 30px;
}

/deep/ .van-icon-apps-o::before {
  font-size: 12px;
}

/deep/ .van-icon-success::before {
  color: #ff3300;
  font-size: 16px;
}
.main-tab {
  margin-top: 25px;
}
</style>
